import { foldazApi } from 'api'
import { groupBy } from '../../utils/helpers'
import {
  FETCH_FOLDERS_REQUEST,
  FETCH_FOLDERS_SUCCESS,
  FETCH_FOLDERS_ERROR,
  SET_WRITABLE_FOLDERS,
  SET_FOLDERS
} from './types'

export const state = {
  folders: [],
  writableFolders: [],
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [FETCH_FOLDERS_REQUEST] (state) {
    state.request.isLoading = true
  },
  [FETCH_FOLDERS_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [FETCH_FOLDERS_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },
  [SET_WRITABLE_FOLDERS] (state, value) {
    state.writableFolders = value
  },
  [SET_FOLDERS] (state, value) {
    state.folders = value
  }
}

export const actions = {
  fetchFolders ({ commit, dispatch }) {
    commit(FETCH_FOLDERS_REQUEST)
    return foldazApi.get('/folders')
      .then(({ data }) => commit(SET_FOLDERS, data.folders))
      .then(() => commit(FETCH_FOLDERS_SUCCESS))
      .catch(error => commit(FETCH_FOLDERS_ERROR, error))
  },
  fetchWritableFolders ({ commit, dispatch }) {
    commit(FETCH_FOLDERS_REQUEST)
    return foldazApi.get('/folders', {
      params: { writable: true }
    })
      .then(({ data }) => commit(SET_WRITABLE_FOLDERS, data.folders))
      .then(() => commit(FETCH_FOLDERS_SUCCESS))
      .catch(error => commit(FETCH_FOLDERS_ERROR, error))
  },
  fetchTeamFolders ({ commit }, teamId) {
    commit(FETCH_FOLDERS_REQUEST)

    return foldazApi.get('/folders', {
      params: {
        team_id: teamId
      }
    })
      .then(({ data }) => {
        commit(FETCH_FOLDERS_SUCCESS)
        return data
      })
      .catch(error => commit(FETCH_FOLDERS_ERROR, error))
  },
}

export const getters = {
  teamFolders: state => teamId => {
    return state.folders.filter(folder => folder.teamId === teamId)
  },
  foldersOptions ({ folders }) {
    return folders.map(({ id, name }) => ({ label: name, value: id }))
  },
  groupedFoldersOptions ({ writableFolders }) {
    const entries = writableFolders.map(({ id, name, team }) => ({ team: team.name, label: name, value: id }))
    const grouped_entries = groupBy(entries, 'team')

    return Object.keys(grouped_entries).map(key => {
      return {
        name: key,
        entries: grouped_entries[key]
      }
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/folders/folders.js